{
    "SectionheaderReportoptions": "Berichtsoptionen",
    "ReporttablabelStyle": "Stil:",
    "ReporttablabelName": "Name:",
    "ReporttablabelFolder": "Mappe:",
    "ReporttablabelNote": "Notiz:",
    "ReporttabReportnameoverwritePromptTextFormatString": "Sie haben den Berichtsstil dieses Berichts geändert - Möchten Sie den bestehenden Namen des Berichts automatisch mit '|1' überschreiben?",
    "NAME": "ReportOptions",
    "ReporttablabelInterval": "Intervall:",
    "ReporttablabelEntity": "Juristische Person:"
}